import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components';
import { useArticleDataState } from '../../../../stores/Configuration/ArticleDataProvider'
import { getLanguageValue } from '../../../../utils/getLanguageValue'
import { colors } from '../../../../styles/colors';
import { FileTypeIcon } from '../../../../utils/getFileTypeIcon'
import ModalComponent from '../../../Modals/ModalComponent'
import { t } from 'i18next';
import { formatedDate } from '../../../../utils/formatedDate'
import UploadDocumentModal from './UploadDocumentModal'

import DocumentIcon from "../../../../assets/icons/document.png"
import DocumentInfoIcon from "../../../../assets/icons/document_info.png"
import DocumentDeleteIcon from "../../../../assets/icons/document_delete.png"
import DocumentUploadIcon from "../../../../assets/icons/document_up.png"
import PhotoIcon from "../../../../assets/icons/Photo.png"
import ExcelIcon from "../../../../assets/icons/excel.svg"
import PDFIcon from "../../../../assets/icons/Pdf.png"
import WordIcon from "../../../../assets/icons/word.svg"
import PowerpointIcon from "../../../../assets/icons/Powerpoint.png"

const StyledDocumentContainer = styled.div`
  position:relative;
  padding: 1rem;
  margin:2px;
  background:${colors.gray6};
  `
const StyledDocumentWrapper = styled.a`
  min-height: 48px;
  color: ${colors.gray4};
  small {
      color: ${colors.gray3};
  }
  margin: 5px 5px 5px 0 ;
  cursor: pointer;
  padding: 0 4rem;
  display: flex;
  justify-content: start;
  align-items: center; 
`

const StyledImage = styled.div`
height:24px;
width:24px;
background-size: contain;
background-image: none;
background-image: url(${props => props.image ? props.image : ""});
`
const StyledFileImgWrap = styled.div`
  box-shadow: 0 0 15px rgb(0 0 0 / 20%);
  background: white;
  width: ${props => props.smallImage ? "50px" : "150px"};
  height:  ${props => props.smallImage ? "50px" : "150px"};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;

  svg {
    width: 100%;
    height: 100%;
    opacity: 0.3;
  }
`
const StyledFileImg = styled.img`
  max-width: 100%;
  max-height: 100%;
`
const renderDocumentTypeIcons = (iconName) => {
    switch (iconName) {
        case 'Artikel':
        case 'Book':
        case 'Date':
        case 'DisplayGrossGruppe':
        case 'Download':
        case 'Earth':
        case 'Flash':
        case 'Hammer':
        case 'Lizenz':
        case 'Mail':
        case 'MailFolder':
        case 'Mass':
        case 'message':
        case 'Open':
        case 'PadNew':
        case 'Paste':
        case 'PeaMeal':
        case 'Pencil':
        case 'Phone':
        case 'Phone2':
        case 'Sort':
        case 'Time':
        case 'uitroep':
        case 'Upload2':
        case 'WÑhrungsrechner':
            return DocumentIcon;
        case 'Photo':
        case 'Picture':
            return PhotoIcon;
        case 'Powerpoint':
            return PowerpointIcon;
        case 'Pdf':
            return PDFIcon;
        case 'Excel':
            return ExcelIcon;
        case 'Winword':
            return WordIcon;
        default:
            return null;
    }
}
const DocumentContainer = ({ documentContainer }) => {
    const [openDeleteModal, setOpenDeleteModal] = useState(false)
    const [openUploadModal, setOpenUploadModal] = useState(false)
    const [useFileUpload, setUseFileUpload] = useState(false)
    const { removeDocument } = useArticleDataState()
    const { document } = documentContainer
    const documentContainerName = getLanguageValue(documentContainer.name.values)
    const documentDescription = document ? getLanguageValue(document.description.values) : null

    const openUploadFile = () => {
        setUseFileUpload(true)
        setOpenUploadModal(true)
    }
    const handleDeleteDocument = async () => {
        const { document } = documentContainer
        await removeDocument(document.id)
        handleClose()
    }
    const handleClose = () => {
        setOpenDeleteModal(false)
        setOpenUploadModal(false)
        setUseFileUpload(false)
    }
    const isImage = document && document.type.includes("image");
    return (
        <>
            <StyledDocumentContainer data-id={documentContainer.id}  >
                <Row>
                    <Col>
                        <div className="d-flex justify-content-start">
                            <StyledImage image={renderDocumentTypeIcons(documentContainer?.iconName ?? '')} />

                            <h4 className="ps-2 mb-0">{documentContainerName}</h4></div>
                    </Col>
                    <Col>
                        <div className="d-flex justify-content-end">

                            <div data-toggle="tooltip" data-placement="right" title={t('documentAdmin:upload')}>
                                <StyledImage style={{ cursor: "pointer" }} image={DocumentUploadIcon} onClick={() => openUploadFile()} />
                            </div>
                            {document &&
                                <>
                                    <div data-toggle="tooltip" data-placement="right" title={t('delete')}>
                                        <StyledImage style={{ cursor: "pointer" }} image={DocumentDeleteIcon} onClick={() => setOpenDeleteModal(true)} />
                                    </div>
                                    <div data-toggle="tooltip" data-placement="right" title={t('documentAdmin:description')}>
                                        <StyledImage style={{ cursor: "pointer" }} image={DocumentInfoIcon} onClick={() => setOpenUploadModal(true)} />
                                    </div>
                                </>
                            }
                        </div>
                    </Col>
                </Row>
            </StyledDocumentContainer>
            {document &&
                <StyledDocumentWrapper href={document.url} download={document.name} filename={document.name} target="_blank">

                    <StyledFileImgWrap>{isImage ? <StyledFileImg src={document.url} alt='' /> : <FileTypeIcon fileType={document.type} />}</StyledFileImgWrap>
                    <div >
                        <div className='fw-bold'>{document.name || ''}</div>
                        <div>
                            <small className='text-uppercase'>{documentDescription || ''}</small>
                        </div>
                        <div>
                            <small className='text-uppercase'>{formatedDate(document?.uploadtime ?? '')}</small>
                        </div>
                        <div>
                            <small className='text-uppercase'>{document?.uploadByDisplayName ?? ''}</small>
                        </div>
                    </div>
                </StyledDocumentWrapper>
            }
            {openDeleteModal && (<ModalComponent
                ModalTitle={documentContainerName}
                functionButton1={() => handleDeleteDocument()}
                textButton1={t('delete')}
                variantButton1="danger"
                variantBody="alert-danger"
                BodyPart1={t('documents:deleteDocumentBody')}
                functionCancel={() => { setOpenDeleteModal(false) }}
            />)}
            {openUploadModal && (<UploadDocumentModal
                containerId={documentContainer.id}
                handleClose={handleClose}
                documentData={document}
                useFileUpload={useFileUpload}
                fileTypes={documentContainer.types}
            />)}
        </>
    )
}
export default DocumentContainer